import React from 'react'
import Button from '../buttons/button'
import CommonModal from '../modalLayout/CommonModal'
const CommonDeleteModal = ({ setShow, show, title, onSucces, isLoading }) => {
    return (
        <CommonModal show={show} setShow={setShow} title={'Delete'} className={'width-md'}>
              <h3 className="delete-survey text-center mb-4">{title}</h3>
          <div className='d-flex justify-content-center'>
              <Button label={'Cancel'} className="borderedBtn me-3" onClick={() => { setShow(false) }} />
            <Button label={isLoading ? "Confirming" : "Confirm"} isLoading={isLoading} disable={isLoading} onClick={onSucces} />
          </div>

        </CommonModal>
    )
}

export default CommonDeleteModal